<script lang="ts">
  import type { PlayerInterface } from '@foundation-player/loader';
  import Refresh from '../assets/icons/Refresh.svelte';
  import type { FocusItem, FocusLayer } from '../focus-manager/focus-types';
  import type { IconButtonSize } from '../types/icon-button';
  import IconButton from './IconButton.svelte';

  export let player: PlayerInterface;
  export let size: IconButtonSize = 'm';
  export let focusLayer: FocusLayer;
  export let focusName: FocusItem;

  export const replay = () => {
    const mediaConfig = player.getMediaConfig();

    if (mediaConfig) {
      // Use the same media config. That means pre-roll ads are shown again,
      // even if playback ended with a post-roll.
      // We overwrite values that the user might have changed during playback.
      player.loadMedia({
        ...mediaConfig,
        // set autoplay, so that the user won't have to click twice (1x replay,
        // 1x play)
        autoplay: true,
        // start the medium at the beginning, not at the time when it last was
        // resumed
        startTime: undefined,
        // keep the muted state (the Foundation Player actually keeps the state
        // by itself, but to be sure we set it explicitly)
        muted: player.isMuted(),
        // keep the playback speed
        playbackSpeed: player.getPlaybackSpeed(),
        // keep the audio language
        audioLanguage: player.getActiveAudioTrack()?.language ?? mediaConfig.audioLanguage,
        // keep the text track language (regarding the deprecated field
        // subtitleLanguage)
        textTrackLanguage:
          player.getActiveTextTrack()?.language ?? mediaConfig.textTrackLanguage ?? mediaConfig.subtitleLanguage,
        // unset the deprecated field, use textTrackLanguage instead
        subtitleLanguage: undefined,
      });
    }
  };
</script>

<!-- Using a slot with a fallback allows the icon to be configured from outside -->
<IconButton title="Erneut abspielen" {size} on:click={replay} {focusLayer} {focusName}>
  <slot>
    <Refresh aria-hidden="true" />
  </slot>
</IconButton>
